import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui'
import { actions as operationActions } from 'ducks/uiOperations'
import { selectors as inPutAwayWIPSelectors, actions as inPutAwayWIPActions } from 'ducks/inventoryEnquiry/stocking/inPutAwayWIP'
import { selectors as productSelectors } from 'ducks/SearchLookUp/productLookup'
import { selectors as quantitySelectors } from 'ducks/inventoryEnquiry/stocking/quantities'
import { search } from 'api/inventoryEnquiry/stocking/inPutAwayWIP';
import { actions as filterActions, selectors as filterSelectors } from 'ducks/common/filters';
import { actions as formActions } from 'ducks/form';

const params = new URLSearchParams(location.search)

export const mapStateToProps = state => ({
  gridName: 'IEStockingQuantitiesInPutAwayWIP',
  columnDefs: inPutAwayWIPSelectors.columns(state),
  rowData: inPutAwayWIPSelectors.data(state),
  isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state),
  appliedFilters: inPutAwayWIPSelectors.filterRow(state) && filterSelectors.getFilters(state, inPutAwayWIPSelectors.filterRow(state).formName),
  gridOptions: inPutAwayWIPSelectors.gridOptions(state),
  isLoading: inPutAwayWIPSelectors.isLoading(state),
  filterRow: inPutAwayWIPSelectors.filterRow(state),
  selectedFilters: inPutAwayWIPSelectors.selectedFilters(state),
  reqParams: (productSelectors.selected(state) || params.get('ProductId'))
    && (quantitySelectors.selected(state) || params.get('Warehouse')) &&
  {
    ProductId: (productSelectors.selected(state) && productSelectors.selected(state).ProductId) || params.get('ProductId'),
    Warehouse: (quantitySelectors.selected(state) && quantitySelectors.selected(state).Warehouse) || params.get('Warehouse')
  },
  apiMethod: search

})

export const actions = {
  getFormSchema: formActions.search,
  changeSelectedForm: formActions.setSelected,
  changeSelectedTab: uiActions.changeSelectedTab,
  setSelectedOrderLine: inPutAwayWIPActions.setSelected,
  changeOperationMode: operationActions.changeOperationMode,
  applyFilters: filterActions.applyFilters
}
